/** Dispatched by Header when the mobile nav overlay opens or closes. */
export const MOBILE_MENU_CHANGE_EVENT = 'vibesite:mobile-menu-change';

export function emitMobileMenuChange(open: boolean) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(MOBILE_MENU_CHANGE_EVENT, { detail: { open } }),
  );
}
